import React from 'react'
import OfferList from './components/OfferList'
import SiteImagesSlider from './components/SiteImagesSlider'
import { Divider } from '@mui/material'
import Articles from './components/Articles'
import PopularProducts from './components/PopularProducts'
import Feedback from './components/Feedback'
import Inspiration from './components/Inspiration'
import SpecialFeatures from './components/SpecialFeatures'
import NewProducts from './components/NewProducts'

const HOME_MAX_WIDTH = 1440

interface PageProps {}

const Page: React.FC<PageProps> = ({}) => {
  return (
    <div>
      <div className='mx-auto' style={{ maxWidth: HOME_MAX_WIDTH + 300 }}>
        <OfferList />
      </div>
      <Divider />
      <div className='mx-auto' style={{ maxWidth: HOME_MAX_WIDTH }}>
        <SiteImagesSlider />
        {/*<Collections />*/}
        <Inspiration />
      </div>
      <div className='mx-auto' style={{ maxWidth: HOME_MAX_WIDTH }}>
        <PopularProducts />
        <SpecialFeatures />
        <Feedback />
        <Articles />
        <NewProducts />
      </div>
    </div>
  )
}

export default Page
